import type { DetailedHTMLProps, ImgHTMLAttributes } from 'react'
import { useEffect, useState } from 'react'

export const ImageWithPlaceholder = ({
  src,
  ...props
}: DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>) => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    if (!src) return

    const img = new Image()

    img.onload = () => {
      setIsLoaded(true)
    }
    img.src = src
  }, [src])

  return isLoaded ? (
    <img
      src={src}
      {...props}
    />
  ) : (
    <div className="inline-block h-full w-full bg-neutral-contrast" />
  )
}
